import { render, staticRenderFns } from "./ExceptAreaAddPage.vue?vue&type=template&id=7a165245&scoped=true&"
import script from "./ExceptAreaAddPage.vue?vue&type=script&lang=js&"
export * from "./ExceptAreaAddPage.vue?vue&type=script&lang=js&"
import style0 from "./ExceptAreaAddPage.vue?vue&type=style&index=0&id=7a165245&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a165245",
  null
  
)

export default component.exports